import clear from "flow/cli/commands/clear";
import clearHistory from "flow/cli/commands/clearHistory";
import dump from "flow/cli/commands/dump";
import env from "flow/cli/commands/env";
import exit from "flow/cli/commands/exit";
import forgetProduct from "flow/cli/commands/forgetProduct";
import get from "flow/cli/commands/get";
import help from "flow/cli/commands/help";
import idCollisionCheck from "flow/cli/commands/idCollisionCheck";
import inspector from "flow/cli/commands/inspector";
import listMenuOrder from "./listMenuOrder";
import man from "flow/cli/commands/man";
import modules from "flow/cli/commands/modules";
import set from "flow/cli/commands/set";
import xGetPathAndSegment from "flow/cli/commands/xGetPathAndSegment";
import ICLICommand from "flow/interfaces/ICLICommand";

const basicCommands: ICLICommand[] = [
    clear,
    clearHistory,
    dump,
    env,
    exit,
    forgetProduct,
    help,
    get,
    listMenuOrder,
    man,
    modules,
    idCollisionCheck,
    inspector,
    set,
    xGetPathAndSegment
];

export default basicCommands;
